import { render } from "./BaseHead.vue?vue&type=template&id=33ad9dec&scoped=true"
import script from "./BaseHead.vue?vue&type=script&lang=js"
export * from "./BaseHead.vue?vue&type=script&lang=js"

import "./BaseHead.vue?vue&type=style&index=0&id=33ad9dec&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ad9dec"]])

export default __exports__